module.exports = __webpack_public_path__ + "img/202501160302.ba4df3ac.png";